import React from 'react';
import { Select as SelectInput, withFormikSupport } from '@fourthwall/components';
const SelectComponent = ({ data, value, name, onChange, onBlur, onSettingUpdate }) => {
    const { id, label, options } = data;
    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }
        onSettingUpdate(id, e.target.value);
    };
    return (React.createElement(SelectInput, { label: label, name: name, value: value || '', options: options, onChange: handleChange, onBlur: onBlur }));
};
export const Select = withFormikSupport(SelectComponent);
